export default __webpack_public_path__ + "static/N0103-772551aa8f7a31c4b7f81af4462ae454.png";